module.exports = __webpack_public_path__ + "img/dark-blue.fa4e199f.jpg";